import { FC } from 'react'
import { DistributionWebsiteDraft } from '../types/types'
import MintWindow from './MintWindow'

interface WebsiteDistributionProps {
  website: DistributionWebsiteDraft
}

const WebsiteDistribution: FC<WebsiteDistributionProps> = ({ website }) => {
  return (
    <div>
      <h4>Website Distribution</h4>
      <MintWindow startDate={website.startDate} endDate={website.endDate} />
      {website.name && (
        <p>
          <strong>Website name:</strong> {website.name}
        </p>
      )}
    </div>
  )
}

export default WebsiteDistribution
